export default {
    methods: {
        initDashboardGraph() {
            let ctx = document.getElementById("graph");
            Chart.defaults.global.defaultFontColor = '#FFF';
            Chart.defaults.global.animation.duration = 2000;
            Chart.defaults.global.legend.display = true;

            if(document.documentElement.clientWidth < 500){
                let myChart = new Chart(ctx, {
                    type: 'bar',
                    data: {
                        labels: ['Form Submissions','Links Clicked','Social Posts','Page Views','Emails Opened','Emails Sent'],
                        datasets: [
                            {
                                data: [
                                    this.vueData.vesselUsage.form_submissions.timeframe_usage,
                                    this.vueData.vesselUsage.clicks.timeframe_usage,
                                    this.vueData.vesselUsage.social_posts.timeframe_usage,
                                    this.vueData.vesselUsage.views.timeframe_usage,
                                    this.vueData.vesselUsage.opens.timeframe_usage,
                                    this.vueData.vesselUsage.emails.timeframe_usage,
                                ],
                                backgroundColor: ['rgba(255, 255, 255, 0.2)','rgba(255, 255, 215, 0.5)','rgba(203, 246, 255, 0.5)','rgba(255, 204, 51, 0.5)','rgba(70, 172, 72, 0.5)','rgba(255, 255, 215, 0.5)'],
                                borderColor: ['#FFFFFF','#FFFFEE','#5798cf','#FFCC33','#46ac48','#FFFFEE'],
                                borderWidth: 2,
                                pointHoverRadius: 15
                            }
                        ]
                    },
                    options: {
                        legend: {
                            display: false
                        },
                        hover: {
                            mode: 'x',
                            intersect: false
                        },
                        tooltips: {
                            mode: 'x',
                            intersect: false
                        },
                        scales: {
                            xAxes: [{
                                display: false
                            }],
                            yAxes: [{
                                display: true,
                                ticks: {
                                    beginAtZero: true,
                                    max: this.vueData.max
                                }
                            }]
                        }
                    }
                });
            }else{
                let myChart = new Chart(ctx, {
                    type: 'bar',
                    data: {
                        labels: ['Form Submissions','Links Clicked','Social Posts','Page Views','Emails Opened','Emails Sent'],
                        datasets: [
                            {
                                data: [
                                    this.vueData.vesselUsage.form_submissions.timeframe_usage,
                                    this.vueData.vesselUsage.clicks.timeframe_usage,
                                    this.vueData.vesselUsage.social_posts.timeframe_usage,
                                    this.vueData.vesselUsage.views.timeframe_usage,
                                    this.vueData.vesselUsage.opens.timeframe_usage,
                                    this.vueData.vesselUsage.emails.timeframe_usage,
                                ],
                                backgroundColor: ['rgba(255, 255, 255, 0.2)','rgba(255, 255, 215, 0.5)','rgba(203, 246, 255, 0.5)','rgba(255, 204, 51, 0.5)','rgba(70, 172, 72, 0.5)','rgba(255, 255, 215, 0.5)'],
                                borderColor: ['#FFFFFF','#FFFFEE','#5798cf','#FFCC33','#46ac48','#FFFFEE'],
                                borderWidth: 2,
                                pointHoverRadius: 15
                            }
                        ]
                    },
                    options: {
                        legend: {
                            display: false
                        },
                        hover: {
                            mode: 'x',
                            intersect: false
                        },
                        tooltips: {
                            mode: 'x',
                            intersect: false
                        },
                        scales: {
                            xAxes: [{
                                display: true
                            }],
                            yAxes: [{
                                display: true,
                                ticks: {
                                    beginAtZero: true,
                                    max: this.vueData.max
                                }
                            }]
                        }
                    }
                });
            }
        }
    }
}